import React, { useEffect, useState } from "react";
import ApiService from "../../../Services/user/service";
import { Copy } from "lucide-react";
import { toast } from "react-toastify";
import { fDateTime } from "../../../Utils/Date_format/datefromat";
const ReferCode = () => {
  const userid = localStorage.getItem("user_id");
  const currency = localStorage.getItem("currentCurrency");
  const [referralData, setReferralData] = useState({});
  const [listData, setListData] = useState([]);

  const fetchReferralCode = async () => {
    try {
      const response = await ApiService.getReferralCode(userid);

      setReferralData({
        referralCode: response.data.referralCode,
        url: response.data.url,
      });
      const users = response.data.data || [];
      setListData(users);
    } catch (error) {
      console.error("Error fetching referral code:", error);
    }
  };

  useEffect(() => {
    fetchReferralCode();
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(referralData?.referralCode);
    toast.success("Referral code copied!");
  };

  const totalEarnings = listData.reduce(
    (sum, item) => sum + Number(item.referral_price || 0),
    0,
  );

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header">
          <div className="card-title">Refer Code</div>
        </div>

        <div className="card-body">
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-4">
            {/* LEFT SIDE */}
            <div className="d-flex flex-column gap-3 flex-grow-1">
              <h5 className="">Invite Friends and Earn Exciting Rewards!</h5>

              {/* Total Referrals */}
              <div className="p-3 rounded border bg-light">
                <span className="fw-semibold">Total Referrals</span>
                <h4 className="text-primary fw-bold mb-0 mt-1">
                  {listData.length}
                </h4>
              </div>

              {/* Total Earnings */}
              <div className="p-3 rounded border bg-light">
                <span className="fw-semibold">Total Earnings</span>
                <h4 className="text-success fw-bold mb-0 mt-1">
                  {currency === "0" ? "$" : "₹"}
                  {totalEarnings}
                </h4>
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div
              className="p-4 border-0 shadow-lg rounded-4 position-relative text-white flex-grow-1 w-100"
              style={{
                maxWidth: "600px",
                background: "linear-gradient(135deg, #3f4fda 0%, #041adf 100%)",
              }}
            >
              {/* Copy Icon – top-right */}
              <span
                onClick={handleCopy}
                style={{
                  position: "absolute",
                  right: "14px",
                  top: "14px",
                  cursor: "pointer",
                  opacity: 0.9,
                }}
              >
                <Copy size={22} className="text-white" />
              </span>

              {/* Title */}
              <h5
                className="mb-1 fw-semibold"
                style={{ letterSpacing: "0.5px" }}
              >
                Your Referral Code
              </h5>

              {/* Referral Code */}
              <p
                className="fw-bold fs-2 mt-2 mb-3"
                style={{ letterSpacing: "3px", textTransform: "uppercase" }}
              >
                {referralData?.referralCode}
              </p>

              {/* Description */}
              <p className="mb-4" style={{ opacity: 0.85 }}>
                Share this code with friends to earn rewards
              </p>

              {/* Share Now Button */}
              <button
                className="btn w-100 fw-semibold"
                style={{
                  background: "#ffffff",
                  color: "#2c3dd8",
                  borderRadius: "10px",
                  padding: "10px 0",
                }}
              >
                Share Now
              </button>
            </div>
          </div>

          <div className="mt-4">
            <h4>Referred Users</h4>

            {listData.length === 0 ? (
              <p className="text-muted mt-2">No referred users yet.</p>
            ) : (
              <div className="table-responsive mt-3">
                <table className="table table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Username</th>

                      <th>Referral Price</th>
                      <th>Joined Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    {listData.map((user, index) => (
                      <tr key={user._id || index}>
                        <td>{index + 1}</td>
                        <td>{user.FullName}</td>
                        <td>{user.UserName}</td>

                        <td>
                          {currency === "1" ? "₹" : "$"} {user.referral_price}
                        </td>
                        {/* <td>{new Date(user.createdAt).toLocaleDateString()}</td> */}
                        <td>{fDateTime(user.createdAt)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferCode;
